import { Component, input, Type } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { IconBase } from '../icons/icon-base';
@Component({
  selector: 'tag',
  imports: [NgComponentOutlet],
  templateUrl: './tag.html',
  styleUrl: './tag.scss',
})
export class Tag {
  active = input(false);
  label = input.required<string>();
  icon = input<Type<IconBase> | null>(null);
}
